// API Configuration for frontend
// This file centralizes the API base URL configuration

// Load environment configuration
require("../config/environment");

// Get API base URL from environment configuration
export const API_BASE = process.env.REACT_APP_API_URL || "";

// Helper function to build API URLs
export const buildApiUrl = (endpoint) => {
  return `${API_BASE}${endpoint}`;
};

// Environment detection
export const isDevelopment = () =>
  process.env.REACT_APP_ENVIRONMENT === "development";
export const isProduction = () =>
  process.env.REACT_APP_ENVIRONMENT === "production";

// Common API endpoints
export const API_ENDPOINTS = {
  APPOINTMENTS: {
    BOOK: "/api/appointments/book",
    SLOTS: "/api/appointments/slots",
    DATA: "/api/appointments/data",
    STATUS: "/api/appointments/status",
    DELETE: "/api/appointments/delete",
    DOWNLOAD: "/api/appointments/files",
  },
  ADMIN: {
    LOGIN: "/api/admin/login",
    PATIENT_INFO: "/api/admin/patient",
    PATIENT_NOTES: "/api/admin/patient/notes",
    PATIENT_REPORTS_UPLOAD: "/api/admin/patient/reports/upload",
    PATIENT_REPORTS_DOWNLOAD: "/api/admin/patient/reports/download",
    PATIENT_REPORTS_DELETE: "/api/admin/patient/reports",
    PATIENTS_LIST: "/api/admin/patients",
    PATIENTS: "/api/admin/patients",
    ADD_PATIENT: "/api/admin/patient/add",
    DELETE_PATIENT: "/api/admin/patient",
  },
  CONTACT: {
    SEND: "/api/contact/send",
  },
};
